import { lazy } from "react";
import { Navigate, type RouteObject } from "react-router-dom";

const Home = lazy(() => import("./home"));
const Form = lazy(() => import("./form"));
const Confirmation = lazy(() => import("./confirmation"));
const ErrorPage = lazy(() => import("./error"));

export const prescriberRoutes: RouteObject[] = [
  {
    path: "/referral-form/*",
    errorElement: <ErrorPage />,
    children: [
      {
        path: "homepage",
        element: <Home />,
        errorElement: <ErrorPage />,
      },
      {
        path: "informations/:id",
        element: <Form />,
        errorElement: <ErrorPage />,
      },
      {
        path: "confirmation",
        element: <Confirmation />,
        errorElement: <ErrorPage />,
      },
      {
        path: "*",
        element: <Navigate to="/referral-form/homepage" replace />,
        errorElement: <ErrorPage />,
      },
    ],
  },
];
